import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["checkbox", "actionButton", "selectAll"];

  connect() {
    this.updateState();
  }

  toggle() {
    this.updateState();
  }

  toggleDay(event) {
    const dayColumn = event.target.closest("[data-day]");
    const checked = event.target.checked;
    this.checkboxTargets
      .filter((cb) => dayColumn.contains(cb))
      .forEach((cb) => {
        cb.checked = checked;
      });
    this.updateState();
  }

  updateState() {
    const checkedCount = this.checkboxTargets.filter((cb) => cb.checked).length;
    this.actionButtonTargets.forEach((aB) => {
      aB.disabled = checkedCount === 0;
    });
  }
}
